import { useState, ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

type ReactQueryProviderProps = {
  children: ReactNode
}

/**
 * This provider should only be used in legacy zones. For anything in main
 * the query provider is defined in the protected-contexts component.
 */
export function ReactQueryProvider({ children }: ReactQueryProviderProps) {
  // Creating the queryClient at the file root level makes the cache shared
  // between all requests and means _all_ data gets passed to _all_ users.
  // Besides being bad for performance, this also leaks any sensitive data.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false, // disable refetching on window focus
            retry: false, // disable retries on error for all queries and mutations
          },
        },
      }),
  )

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}
